import React from "react";
import { Separator } from "@commonsku/design-system";
import { selectVisibleAssignedTasks, TaskListSectionsProps } from "../../../redux/myTasks";
import TaskSection from "./TaskSection";

/**
 * Assigned Tasks: tasks your team completed since you last checked, then
 * everything still in progress. See selectVisibleAssignedTasks for the
 * "Recently Completed" / "In Progress" split, the drop of already-seen
 * completions, and the TASKS_DISPLAY_LIMIT cap - TasksMenuPanel relies on
 * that same selector to know whether this panel has anything to show.
 */
const AssignedTasksSections = ({ tab, notes, seenAt, onToggleComplete }: TaskListSectionsProps) => {
  const { recentlyCompleted: visibleRecentlyCompleted, inProgress: visibleInProgress } = selectVisibleAssignedTasks(
    notes,
    seenAt,
  );

  return (
    <>
      <TaskSection
        heading="Recently Completed"
        tab={tab}
        notes={visibleRecentlyCompleted}
        onToggleComplete={onToggleComplete}
      />
      {visibleRecentlyCompleted.length > 0 && visibleInProgress.length > 0 && <Separator marginY="1" />}
      <TaskSection heading="In Progress" tab={tab} notes={visibleInProgress} onToggleComplete={onToggleComplete} />
    </>
  );
};

export default AssignedTasksSections;
